module.exports = __webpack_public_path__ + "img/Pakistan.8ef0c651.gif";